import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Guest, Waiver, BasicInfo, ContactInfo, SignedWaiver } from "../models/waiver";
import { ToolsService } from "./tools.service";
import { StoreService } from "./store.service";
import { Subject } from "rxjs";
import { WaiverSteps } from "../alv-enums";

@Injectable({
    providedIn: 'root',
})

export class WaiverService {

    public waiverStepsVisited: WaiverSteps[] = [];
    currentWaiverStep: WaiverSteps = WaiverSteps.email;

    constructor(
        private dataService: DataService,
        protected toolsService: ToolsService,
        protected storeService: StoreService
    ) {

    }

    public onStepChangeForward(step: WaiverSteps) {
        this.waiverStepsVisited.push(step);
        this.currentWaiverStep = step;
    }

    public onStepChangeBackwords() {
        this.waiverStepsVisited.pop();
        this.currentWaiverStep = this.waiverStepsVisited.length > 0 ? this.waiverStepsVisited[this.waiverStepsVisited.length - 1] : WaiverSteps.email;
    }

    lookupGuestAccountByEmail(email: string) {
        return this.dataService.get<any>(`/Waiver/LookupGuestAccountByEmail/?email=${email}`)
    }

    LookupGuestList(guestAccountId: number, waiverId: number) {
        const timezoneOffset = new Date().getTimezoneOffset();
        return this.dataService.get<any>(`/Waiver/LookupGuestList/?guestAccountId=${guestAccountId}&waiverId=${waiverId}&timeZoneOffset=${timezoneOffset}`)
    }

    loginWaiverUser(username: string, password: string) {
        const postData = {
            username: username,
            password: password
        };

        return this.dataService.post<any>(`/Waiver/LoginWaiver`, postData);
    }

    resetPassword(email: string, guestAccountId: number) {
        const postData = {
            email: email,
            guestAccountId: guestAccountId
        };

        return this.dataService.post<any>(`/Waiver/SendNewPassword`, postData);
    }
    public getSignWaiver(waiverId: number) {
        return this.dataService.get<any>(`/Waiver/SignWaiver/?waiverId=${waiverId}`)
    }
    submitSignWaiver(waiver: SignedWaiver) {
        if (waiver.waiverCustomFieldFilledFormList && waiver.waiverCustomFieldFilledFormList.length > 0) {
            waiver.waiverCustomFieldFilledFormList.forEach(field => {
                // Convert fieldValue to string if it exists and isn't already a string
                if (field.fieldValue !== null && field.fieldValue !== undefined) {
                    field.fieldValue = String(field.fieldValue);
                }
            });
        }
        return this.dataService.post<any>('/Waiver/SignWaiver', waiver);
    }

}

